import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://tkrblcbgqcazocqagnky.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRrcmJsY2JncWNhem9jcWFnbmt5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMwMTU1MTYsImV4cCI6MjA4ODU5MTUxNn0.FllhkqappGDe8GXTUjdw6aBiHnRsfwGHp4A8u8LvUjc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
